import React, { FC } from "react";
import PageLegalDocument from "containers/PageLegalDocument";

const PageUserAgreement: FC = () => (
	<PageLegalDocument contentKey="userAgreementContent" titleI18nKey="nav.user_agreement" />
);

export default PageUserAgreement;
